// export const api = "https://universitysolutions.in/collportal/app.php?a=";

// export const API =
//   window.location.protocol + "//universitysolutions.in/tdvs-php";

// export const API = window.location.protocol + "//localhost:81/tdvs-php";
export const API = "https://nitteblrdvs.logisys.org/tdvs-php";

export const abpath = "https://nitteblrdvs.logisys.org/eval-img/";

// export const abpath = " http://172.18.16.6:8081/eval-img/";
